import React from "react";

const HeaderButton = ({
    type = 'submit',
    labelText = null,
    onClick = null,
    icon = null,
    srcIcon = null,
    altIcon = null,
    className = null,
    iconClassName = null,
    textClassName = null,
    isActive = false,
    ...attrs
}) => (
    <button
        type={type}
        className={`inline-flex flex-col justify-center items-center hover:bg-alice-blue-3 ${isActive && "bg-alice-blue-3"} ${className}`}
        onClick={onClick}
        {...attrs}
    >
        {icon ? icon : <img src={srcIcon} alt={altIcon} className={iconClassName} />}
        <span className={`leading-none whitespace-nowrap mt-1.25 text-2xs ${isActive ? "text-primary" : "text-midnight"} ${textClassName}`}>{labelText}</span>
    </button>
);

export default HeaderButton;
